import { Component, Vue } from "vue-property-decorator";
import { Getter, Action } from "vuex-class";
import { patientNamespace } from "@/store/modules/patient";
import _ from "lodash";
import { Patient } from "@/store/modules/patient/types";

@Component({})
export default class CareNote extends Vue {
  @Getter("current", patientNamespace)
  current!: Patient;

  get problemList() {
    return _.get(this.current, "body.current.ProblemList.text", "").split("|");
  }

  get stickyNote() {
    return _.get(this.current, "body.current.OBStickyNote.text", "");
  }

  get greaseboardNote() {
    return _.get(this.current, "body.current.GreaseBoardNotes.text", "").trim();
  }

  @Getter("careCoordinationNote", patientNamespace)
  careCoordinationNote!: Function;

  @Action("getCareCoordinationNote", patientNamespace)
  getCareCoordinationNote!: Function;

  @Action("clearCareCoordinationNote", patientNamespace)
  clearCareCoordinationNote!: Function;

  mounted() {
    this.clearCareCoordinationNote();
    if (_.get(this.current, "body.current.CareCoordinationNote.value", 0) > 0) {
      this.getCareCoordinationNote();
    }
  }
}
